"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("../type");
var type_checker_1 = require("../type-checker");
var OptionalValue = (function (_super) {
    __extends(OptionalValue, _super);
    function OptionalValue(type, defaultValue) {
        var _this = _super.call(this, type.name) || this;
        _this.type = type;
        _this.defaultValue = defaultValue;
        return _this;
    }
    OptionalValue.prototype.describe = function () {
        // return "(" + this.type.type.describe() + " = " + JSON.stringify(this.defaultValue) + ")"
        // MWE: discuss a default value is not part of the type description? (unlike a literal)
        return this.type.describe() + "?";
    };
    OptionalValue.prototype.create = function (value) {
        if (typeof value === "undefined") {
            var defaultValue = typeof this.defaultValue === "function" ? this.defaultValue() : this.defaultValue;
            var defaultSnapshot = mst_node_1.isMST(defaultValue) ? mst_node_1.getMSTAdministration(defaultValue).snapshot : defaultValue;
            return this.type.create(defaultSnapshot);
        }
        return this.type.create(value);
    };
    OptionalValue.prototype.validate = function (value, context) {
        // defaulted values can be skipped
        if (value === undefined || this.type.is(value)) {
            return type_checker_1.typeCheckSuccess();
        }
        return type_checker_1.typeCheckFailure(context, value);
    };
    Object.defineProperty(OptionalValue.prototype, "identifierAttribute", {
        get: function () {
            return this.type.identifierAttribute;
        },
        enumerable: true,
        configurable: true
    });
    return OptionalValue;
}(type_1.Type));
exports.OptionalValue = OptionalValue;
function optional(type, defaultValueOrFunction) {
    var defaultValue = typeof defaultValueOrFunction === "function" ? defaultValueOrFunction() : defaultValueOrFunction;
    var defaultSnapshot = mst_node_1.isMST(defaultValue) ? mst_node_1.getMSTAdministration(defaultValue).snapshot : defaultValue;
    type_checker_1.typecheck(type, defaultSnapshot);
    return new OptionalValue(type, defaultValueOrFunction);
}
exports.optional = optional;
var mst_node_1 = require("../../core/mst-node");
//# sourceMappingURL=optional.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/utility-types/optional.js
// module id = 50
// module chunks = 0